import { getToken } from "./apiHelper";
import api from "./api";

export const currentService = {

  getCurrents: async ( ) => {
    try {
      let axiosConfig = {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }; 
      const response = await api.get(`/Currents/getall`,  axiosConfig);
  
      return response.data;
    } catch (error) {
      console.error("error:", error);
      throw error;
    }  
  },
};